import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/imgs/headshots/mike-armitage.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Photo of Mike Armitage"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Mike Armitage"),
  /*#__PURE__*/_createElementVNode("h3", null, "CTO"),
  /*#__PURE__*/_createElementVNode("p", null, "Michael comes to us with over 10 years of experience in various asset management roles within futures settlements, trading and private wealth management. As IT Director for Stanhope Capital, Michael was fundamental in the creation of an entire business workflow solution. As Chief Architect to BRT, a business process outsourcing and bespoke software solution provider for wealth managers, funds, private banks and trusts, he created a white label SAAS version of the solution which was then made available to the rest of BRT's clients.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile = _resolveComponent("profile")!

  return (_openBlock(), _createBlock(_component_profile, null, {
    headshot: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }))
}